module.exports = __webpack_public_path__ + "media/src/images/new-kddi-logo-63db151fe6839695ebcfb1a471101d87.png";